import { useAppSelector } from "../../redux/store/hooks";
import { domainRoleHomes } from "../../config/domain-config";
import PlatformOwnerHome from "./role/PlatformOwnerHome";
import PlatformHome from "./role/PlatformHome";

// Home screen — dispatches to a role-specific dashboard. Employee and Broker
// have their own dedicated landing routes (employee-portal / broker-dashboard)
// and never reach this screen.
//
// The routing is platform; the content is not. Owner/Admin/Manager dashboards
// all report on products, orders and sales, so they live in the domain and are
// registered through `domainRoleHomes` rather than imported here. A role the
// product has not registered falls back to PlatformHome, which is what keeps a
// fresh project (with no domain at all) landing somewhere real.
//
// Platform Owner is the exception: that dashboard reports on organizations and
// revenue — platform data — so it stays a direct import.
const Home = () => {
  const role = useAppSelector((s) => s.layout.user.role);

  if (role === "platform owner") return <PlatformOwnerHome />;

  const DomainHome = domainRoleHomes?.[role as keyof typeof domainRoleHomes];
  return DomainHome ? <DomainHome /> : <PlatformHome />;
};

export default Home;
